import { ref, onUnmounted } from 'vue'
import gsap from 'gsap'
import { Flip } from 'gsap/Flip'

gsap.registerPlugin(Flip)

export function useScanModal() {
  const modalRef = ref(null)
  const overlayRef = ref(null)
  const modalContentRef = ref(null)
  const isAnimating = ref(false)

  let activeBlock = null
  let originalSlot = null

  const DURATION = 0.7
  const EASE = 'power1.inOut'

  const toggleBlock = (e) => {
    if (isAnimating.value) return
    const block = e.target.closest('.scan-preview__block')
    if (!block) return
    activeBlock ? closeBlock() : openBlock(block)
  }

  const openBlock = (block) => {
    isAnimating.value = true
    activeBlock = block
    originalSlot = block.parentElement

    const state = Flip.getState(block)
    modalContentRef.value.appendChild(block)

    document.body.style.overflow = 'hidden'
    gsap.set(modalRef.value, { autoAlpha: 1 })
    gsap.to(overlayRef.value, { autoAlpha: 0.65, duration: 0.35 })
    gsap.to(block.querySelectorAll('.scan-preview__icon span'), {
      maxWidth: 80, duration: DURATION, ease: EASE,
    })
    gsap.to(block.querySelectorAll('.scan-preview__icon svg'), {
      marginLeft: 5, duration: DURATION, ease: EASE,
    })
    gsap.to(block.querySelectorAll('.scan-preview__icon'), {
      padding: '4px 8px', duration: DURATION, ease: EASE,
    })
    gsap.to(block.querySelector('.scan-preview__actions'), {
      bottom: 12, right: 12, duration: DURATION, ease: EASE,
    })
    Flip.from(state, {
      duration: DURATION,
      ease: EASE,
      onComplete: () => { isAnimating.value = false },
    })
  }

  const closeBlock = () => {
    if (!activeBlock || isAnimating.value) return

    isAnimating.value = true
    const block = activeBlock
    const slot = originalSlot
    activeBlock = null
    originalSlot = null

    gsap.to(block.querySelectorAll('.scan-preview__icon'), {
      padding: '3px 5px', duration: DURATION, ease: EASE,
    })
    gsap.to(block.querySelectorAll('.scan-preview__icon span'), {
      maxWidth: 0, duration: DURATION, ease: EASE,
    })
    gsap.to(block.querySelectorAll('.scan-preview__icon svg'), {
      marginLeft: 0, duration: DURATION, ease: EASE,
    })
    gsap.to(block.querySelector('.scan-preview__actions'), {
      bottom: 4, right: 4, duration: DURATION, ease: EASE,
    })

    slot.appendChild(block)
    const targetState = Flip.getState(block)
    modalContentRef.value.appendChild(block)

    gsap.to(overlayRef.value, { autoAlpha: 0, duration: 0.35 })
    Flip.to(targetState, {
      duration: DURATION,
      ease: EASE,
      absolute: true,
      onComplete: () => {
        slot.appendChild(block)
        gsap.set(block, { clearProps: 'all' })
        gsap.set(modalRef.value, { autoAlpha: 0 })
        document.body.style.overflow = ''
        isAnimating.value = false
      },
    })
  }

  onUnmounted(() => {
    if (activeBlock && originalSlot) originalSlot.appendChild(activeBlock)
    document.body.style.overflow = ''
  })

  return { modalRef, overlayRef, modalContentRef, toggleBlock, closeBlock }
}
